import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsEnIsoLiquidLimitMethodASection, BsEnIsoPlasticLimitSection, BsEnIsoPreparationSection } from './Sections';
import { BsEnIsoResultsSectionMethodA } from './Sections/Results';

const qestIds = [ids.atterbergLimit.BS_EN_ISO_17892_12_2018.rev2018_2022_methodA];

let BsEnIsoAtterbergLimitWorksheetMethodA: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <BsEnIsoPreparationSection />
      </PageSection>
      <PageSection heading="Liquid Limit">
        <BsEnIsoLiquidLimitMethodASection />
      </PageSection>
      <PageSection heading="Plastic Limit">
        <BsEnIsoPlasticLimitSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <BsEnIsoResultsSectionMethodA />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsEnIsoAtterbergLimitWorksheetMethodA.qestIds = qestIds;

export default BsEnIsoAtterbergLimitWorksheetMethodA;
